import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'

import { selectSelectedAnnotationIds } from '../app/interface.js'
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons'

import { selectAnnotations } from '../app/annotations.js';
import SelectedAnnotation from './SelectedAnnotation.jsx';

function SideBar(props) {
  const [closed,setClosed] = useState(false)
  const selectedAnnotationsIds = useSelector(selectSelectedAnnotationIds)
  const annotations = useSelector(selectAnnotations)
  const [selectedAnnotations, setSelectedAnnotations] = useState([])

  // update selected annotations
  useEffect(() => {
    if (selectedAnnotationsIds && annotations)
      setSelectedAnnotations(annotations.filter(a => selectedAnnotationsIds.includes(a.id)))
  }, [selectedAnnotationsIds, annotations])

  useEffect(() => {
    document.body.classList.toggle('overflowHidden', !closed);
  },[closed])

  useEffect(() => {
    return () => {
      document.body.classList.remove('overflowHidden');
    };
  }, []);

  useEffect(() => {
    if(selectedAnnotationsIds.length === 0){
      setClosed(true)
    }else{
      setClosed(false)
    }
  }, [selectedAnnotationsIds])

  return <aside className={`sidebar sidebar-right ${closed ? "closed" : ""}`}>
    <div className="annotations-sidebar-container">
      <span className="sidebar-closer" style={{marginTop:"5px"}} onClick={(e) => setClosed(!closed)}>
          {closed ? <FontAwesomeIcon icon={faChevronLeft}/> : <FontAwesomeIcon icon={faChevronRight}/>}
        </span>

      <h3>
        
      </h3>
      <SelectedAnnotation />

      {/* <div className="annotations-container">
        {annotations.map((a) => <Annotation key={`annot-${a.id}`} a={a} selected={(selectedAnnotation !== undefined) && (a.id === selectedAnnotation.id)}/>)}
      </div> */}
    </div>
  </aside>
}

export default SideBar;